import { FC } from "react";

const DropdownPossibleNextStep: FC = (): JSX.Element => {
  return (
    <li className="nav-item dropdown">
      <button className="nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
        Treatment Status Meaning
      </button>

      <ul className="dropdown-menu dropdown-menu-end p-2 status-dropdown">
        <p className="m-0">
          On the case screen, you can update the treatment status of your case. Below is an explanation of the options potentially available: 
        </p>
        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li>
          <div className="row">
            <div className="col-sm-4">
              <span className="btn btn-green btn-sm rounded-0">
                <i className="fa fa-times"></i> Treatment Scheduled
              </span>
            </div>
            <div className="col-sm-8">
              Selecting this button will allow you to enter the patient's planned upcoming treatment date. It can be changed if necessary.
              Please remember to mark the case Treated after they receive their actual QUTENZA application
            </div>
          </div>
        </li>

        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li>
          <div className="row">
            <div className="col-sm-4">
              <span className="btn btn-green btn-sm rounded-0">
                <i className="far fa-clipboard"></i> Treated
              </span>
            </div>
            <div className="col-sm-8">
              Selecting this button will allow you to enter the actual treatment date of the patient's application of QUTENZA. We can
              send you a new benefit investigation three weeks before they are due for their next application if you provide their
              treatment date.
            </div>
          </div>
        </li>

        <li>
          <hr className="dropdown-divider"/>
        </li>

        <li>
          <div className="row">
            <div className="col-sm-4">
              <span className="btn btn-green btn-sm rounded-0">
                <i className="fa fa-times"></i> Not Treating
              </span>
            </div>
            <div className="col-sm-8">
              Select this button if the patient has opted to not move forward with treatment or the doctor has decided
              to not treat the patient. Several reasons are provided for you to choose.
            </div>
          </div>
        </li>

        <li>
          <hr className="dropdown-divider"/>
        </li>
        <li>
          <div className="row">
            <div className="col-sm-4">
              <span className="btn btn-green btn-sm rounded-0">
                <i className="fas fa-prescription"></i> Transfer to Centerwell
              </span>
            </div>
            <div className="col-sm-8">
              Select this button if you would like this prescription filled by Centerwell Specialty Pharmacy. Option
              not available for all cases.
            </div>
          </div>
        </li>
        <li>
          <hr className="dropdown-divider"/>
        </li>
        <li>
          <div className="row">
            <div className="col-sm-4">
              <span className="btn btn-green btn-sm rounded-0">
                <i className="fas fa-prescription"></i> Transfer to Alliance Rx Walgreens
              </span>
            </div>
            <div className="col-sm-8">
              Select this button if you would like this prescription filled by Walgreens Alliance Specialty Pharmacy. Option
              not available for all cases.
            </div>
          </div>
        </li>
         <li>
          <hr className="dropdown-divider"/>
        </li>
        <li>
          <div className="row">
            <div className="col-sm-4">
              <span className="btn btn-green btn-sm rounded-0">
                <i className="fas fa-prescription"></i> Transferred to other Specialty Pharmacy
              </span>
            </div>
            <div className="col-sm-8">
              Selecting this button indicates that your office has already transferred this case to a local Specialty Pharmacy.
              {' '}Option not available for all cases.
            </div>
          </div>
        </li>
      </ul>
    </li>
  );
};

export default DropdownPossibleNextStep;
